import { api } from 'utility';
import { getIncomeBasedOnGuildUrl } from 'URLs';
export function getIncome(data, params) {
  return api.post(getIncomeBasedOnGuildUrl(), data, { params }).then((res) => res.data);
}

export default {
  getIncome,
};
